import { twMerge } from "tailwind-merge"

import { ArrowIcon } from "@/components/flow/icons/ArrowIcon"

export const ArrowButton = ({
  direction = "left",
  disabled = false,
  onClick,
  className = "",
}: {
  direction?: "left" | "right"
  disabled?: boolean
  onClick?: () => void
  className?: string
}) => {
  return (
    <button
      onClick={onClick}
      className={twMerge("hidden h-[60px] w-[60px] items-center justify-center rounded-full bg-white text-2xl lg:flex", direction === "right" ? "" : "-scale-x-100", className)}
      style={{
        boxShadow: "0px 4px 16px 0px #00000040",
      }}
    >
      <ArrowIcon className={twMerge(disabled ? "text-nelo-dark-gray" : "")} />
    </button>
  )
}
